export const initialDebugger = {
	content: [],
}
